// extracted by mini-css-extract-plugin
export default {"main":"carousel_main__1xjy2","button":"carousel_button__VYRgH","banners":"carousel_banners__gXgkU","item":"carousel_item__ppM6X"};